import React from 'react'
import EditableObject from "../../components/3dObject/index"
import Design from "../../components/design/index"

const HomePage = () => {
    return (
        <div>
            <Design></Design>
            <EditableObject />
        </div>
    )
}

export default HomePage
